import { render, staticRenderFns } from "./DmPreislisteDetail.vue?vue&type=template&id=3f150161&scoped=true&"
import script from "./DmPreislisteDetail.vue?vue&type=script&lang=js&"
export * from "./DmPreislisteDetail.vue?vue&type=script&lang=js&"
import style0 from "./DmPreislisteDetail.vue?vue&type=style&index=0&id=3f150161&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f150161",
  null
  
)

export default component.exports